import { GeofencesService } from '../services/geofences-service';
import { TerminalGeofencesModelBase } from './terminal-geofences-model';
import { ZoneFeature } from './zones-base-interfaces';
import { IndexedDBService } from '../../indexed-db/services/db_service';

export class TerminalGeofencesModelImpl extends TerminalGeofencesModelBase {
    private _zones: ZoneFeature[] | null = null;
    private _loadingPromise: Promise<void> | null = null;
    async getTerminalGeofences(): Promise<ZoneFeature[] | null> {
        await this._loadingPromise;
        if (!this._zones) {
            console.error('Zones data is not available.');
            return null;
        }

        return this._zones || [];
    }

    constructor(geojson?: ZoneFeature[]) {
        super();
        if (geojson) {
            this._zones = geojson;
        } else {
            this._loadingPromise = this._loadGeoJson();
            setInterval(() => this._loadGeoJson(), 24*60*60*1000); // refresh terminal geofences every 24h
        }
    }

    private async _loadGeoJson() {
        try {
            const zones: ZoneFeature[] = await GeofencesService.fetchGeofenceByZone('TERMINAL');
            if (zones) {
                this._zones = zones;
                await IndexedDBService.zones.save('TERMINAL', zones);
            }
        } catch (error) {
            console.warn('Failed to fetch TERMINAL zones from API, falling back to IndexedDB', error);
            const cached = await IndexedDBService.zones.getByType('TERMINAL');
            if (cached) {
                this._zones = cached;
            }
        }
    }
}